// AUTO-GENERATED by codegen.ts from the OpenAPI spec + agent-tool-manifest snapshot. Do not edit.
import type { AgentClientToolDescriptor, AgentToolDescriptor } from "../common/agent/agentTypes";

export const agentToolCatalog: AgentToolDescriptor[] = [
  {
    "toolName": "listMyUpcomingDeadlines",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Lister fristene dine. Gir fristene som forfaller de neste withinDays dagene, nærmeste først, på tvers av anskaffelser (tilbudsfrist, frist for forespørsel, forhandlingsrunde, karenstid) og kontrakter (slutt, opsjon, fornyelse, oppsigelse, varsel, garanti). Bare frister brukeren har tilgang til. Bruk dette for «hva haster» og for kontrakter som utløper eller har opsjoner snart. Sett withinDays til vinduet brukeren ber om, upcomingLimit til 50 og overdueDays til 0, så kommer bare frister fra i dag og fremover. Spør brukeren bare om kontraktsfrister (slutt, opsjon, fornyelse, oppsigelse, varsel), sett subjects til CONTRACTS, så fylles ikke lista opp med anskaffelsesfrister. Har svaret upcomingCutShortAt, stoppet lista ved grensen på den datoen: frister etter den har du ikke sett.",
    "params": [
      {
        "name": "withinDays",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "overdueDays",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "upcomingLimit",
        "in": "query",
        "required": false,
        "description": "Upcoming deadlines per page, at most 50.",
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "subjects",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string",
          "enum": [
            "ALL",
            "CONTRACTS",
            "SOURCING_EVENTS"
          ]
        }
      },
      {
        "name": "overdueLimit",
        "in": "query",
        "required": false,
        "description": "Overdue deadlines per page, at most 50.",
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "upcomingAfter",
        "in": "query",
        "required": false,
        "description": "The nextUpcomingPosition of the previous page. That page then runs on past withinDays.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "overdueAfter",
        "in": "query",
        "required": false,
        "description": "The nextOverduePosition of the previous page. That page then runs on past overdueDays.",
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "listBuyerEvents",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Lister anskaffelser med status og frister",
    "entityKind": "v2Event",
    "params": [
      {
        "name": "needsSentFrom",
        "in": "query",
        "required": false,
        "description": "Only procurements created from needs first sent on or after this date, among the needs the caller may take, as counted on Oversikt › Behov. Needs `needsSentTo`. The response then says in `notVisible` how many of those procurements, in the statuses asked for, the caller may not see. Refused to an organization whose plan has no needs.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "needsSentTo",
        "in": "query",
        "required": false,
        "description": "Only procurements created from needs first sent on or before this date. Needs `needsSentFrom`.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "statuses",
        "in": "query",
        "required": false,
        "description": "Filtrer på status.",
        "schema": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "DRAFT",
              "PUBLICATION_PENDING",
              "PUBLISHED",
              "PUBLICATION_FAILED",
              "EVALUATION",
              "EVALUATED",
              "AWARD_DECISION",
              "AWARDED",
              "CANCELLED",
              "CLOSED",
              "COMPLETED"
            ]
          }
        }
      },
      {
        "name": "active",
        "in": "query",
        "required": false,
        "description": "Only procurements under way: past drafting and not yet awarded, cancelled or closed.",
        "schema": {
          "type": "boolean"
        }
      },
      {
        "name": "projectIds",
        "in": "query",
        "required": false,
        "description": "Filtrer på tilknyttet prosjekt.",
        "schema": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      {
        "name": "name",
        "in": "query",
        "required": false,
        "description": "Filtrer på navn (delstreng)",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "tableSearchTerm",
        "in": "query",
        "required": false,
        "description": "Only procurements whose title, internal reference or responsible person's name contains this text, in any case. `%`, `_` and `\\` stand for themselves.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "responsiblePersons",
        "in": "query",
        "required": false,
        "schema": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      {
        "name": "contractTypes",
        "in": "query",
        "required": false,
        "description": "Filtrer på kontraktstype.",
        "schema": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "WORKS",
              "SUPPLIES",
              "SERVICES",
              "COMBINED"
            ]
          }
        }
      },
      {
        "name": "deadlinePassed",
        "in": "query",
        "required": false,
        "description": "Bare anskaffelser der fristen allerede har gått ut.",
        "schema": {
          "type": "boolean"
        }
      },
      {
        "name": "publishedFrom",
        "in": "query",
        "required": false,
        "description": "Only procurements published on or after this date.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "publishedTo",
        "in": "query",
        "required": false,
        "description": "Only procurements published on or before this date.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "awardedFrom",
        "in": "query",
        "required": false,
        "description": "Only procurements awarded on or after this date.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "awardedTo",
        "in": "query",
        "required": false,
        "description": "Only procurements awarded on or before this date.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "bidDeadlineFrom",
        "in": "query",
        "required": false,
        "description": "Only competitions (published, taking competing bids) whose bid deadline is on or after this date.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "bidDeadlineTo",
        "in": "query",
        "required": false,
        "description": "Only competitions (published, taking competing bids) whose bid deadline is on or before this date.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "deadlineFrom",
        "in": "query",
        "required": false,
        "description": "Only procurements whose deadline in force, as the list shows it, is on or after this date.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "deadlineTo",
        "in": "query",
        "required": false,
        "description": "Only procurements whose deadline in force, as the list shows it, is on or before this date.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "deadlinePreset",
        "in": "query",
        "required": false,
        "description": "A deadline period counted from today, the same choices as the contract list's date filters. Overrides deadlineFrom and deadlineTo.",
        "schema": {
          "type": "string",
          "enum": [
            "THIS_YEAR",
            "NEXT_90_DAYS",
            "NEXT_YEAR",
            "PASSED"
          ]
        }
      },
      {
        "name": "minDeliveredBids",
        "in": "query",
        "required": false,
        "description": "Only procurements with at least this many delivered bids.",
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "maxDeliveredBids",
        "in": "query",
        "required": false,
        "description": "Only procurements with at most this many delivered bids.",
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "procedureTypes",
        "in": "query",
        "required": false,
        "description": "Only public procurements run under one of these procedures.",
        "schema": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "OPEN",
              "OPEN_TENDER_COMPETITION",
              "RESTRICTED",
              "RESTRICTED_TENDER_COMPETITION",
              "NEGOTIATED_WITH_PRIOR_CALL",
              "NEGOTIATED_WITHOUT_PRIOR_CALL",
              "COMPETITIVE_DIALOGUE",
              "INNOVATION_PARTNERSHIP",
              "COMPETITIVE_NEGOTIATION",
              "OTHER_SINGLE_STAGE",
              "DYNAMIC_PURCHASING_SYSTEM",
              "DPS_COMPETITION",
              "QUALIFICATION_SCHEME",
              "WITHOUT_COMPETITION",
              "DESIGN_CONTEST_OPEN",
              "DESIGN_CONTEST_RESTRICTED"
            ]
          }
        }
      },
      {
        "name": "regulationBuckets",
        "in": "query",
        "required": false,
        "description": "Only procurements under one of these regulations and parts.",
        "schema": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "FOA_PART_I",
              "FOA_PART_II",
              "FOA_PART_III",
              "FOA_PART_IV",
              "UTILITIES",
              "CONCESSIONS",
              "OUTSIDE_REGULATION",
              "NOT_STATED",
              "NOT_CLASSIFIED",
              "PRIVATE"
            ]
          }
        }
      },
      {
        "name": "limit",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "skip",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "sortBy",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string",
          "enum": [
            "TITLE",
            "REFERENCE_NUMBER",
            "DEADLINE",
            "CREATED_AT",
            "MODIFIED_AT",
            "PROCEDURE",
            "REGULATION",
            "STATUS",
            "RESPONSIBLE",
            "CONTRACT_TYPE",
            "CREATED_BY"
          ]
        }
      },
      {
        "name": "sortDirection",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string",
          "enum": [
            "ASC",
            "DESC"
          ]
        }
      }
    ]
  },
  {
    "toolName": "getSourcingEvent",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Henter detaljer og konfigurasjon for én anskaffelse.",
    "params": [
      {
        "name": "recordView",
        "in": "query",
        "required": false,
        "description": "Defaults to true. False reads the event without adding it to the person's recently viewed list.",
        "schema": {
          "type": "boolean"
        }
      },
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "getSourcingEventReadiness",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Sjekker hva som mangler før en anskaffelse kan publiseres.",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "getEvaluation",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Henter innkomne tilbud med poeng og rangering.",
    "params": [
      {
        "name": "round",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "getBuyerSeQuestions",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Henter spørsmål fra leverandører (Q&A).",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "getBuyerSupplierInformation",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Henter informasjon publisert til leverandører.",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "getAwardLetters",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Henter tildelingsbrev (utkast, godkjent, sendt).",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "listContractReports",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Lister kontrakter",
    "entityKind": "contract",
    "params": [
      {
        "name": "titleFilter",
        "in": "query",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Kontrakter med dette i navnet (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "counterpartyName",
        "in": "query",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Kontrakter der motparten (leverandøren) har dette i navnet, f.eks. «Alfheim Renhold» (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "counterpartyContactFullName",
        "in": "query",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Kontrakter der motpartens kontaktperson har dette i navnet (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "counterpartyContactEmail",
        "in": "query",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Kontrakter der motpartens kontaktperson har dette i e-postadressen (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "counterpartyContactPhoneNumber",
        "in": "query",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Kontrakter der motpartens kontaktperson har dette i telefonnummeret (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "projectSearchTerm",
        "in": "query",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Kontrakter i et prosjekt med dette i navnet eller prosjektnummeret (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "internalOwnerSearchTerm",
        "in": "query",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Kontrakter der den ansvarlige personen har dette i navnet (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "internalPartySearchTerm",
        "in": "query",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Kontrakter der en intern part (avdeling eller virksomhet) har dette i navnet (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "descriptionSearchTerm",
        "in": "query",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Kontrakter med dette i beskrivelsen (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "referenceNumberSearchTerm",
        "in": "query",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Kontrakter med dette i referansenummeret (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "templateNameSearchTerm",
        "in": "query",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Kontrakter laget fra en kontraktsmal med dette i navnet (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "originSourcingEventName",
        "in": "query",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Kontrakter fra en anskaffelse med dette i navnet (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "linkedContractTitleSearchTerm",
        "in": "query",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Kontrakter koblet til en kontrakt med dette i navnet (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "publishedBySearchTerm",
        "in": "query",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Kontrakter publisert av en person med dette i navnet (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "terminatedBySearchTerm",
        "in": "query",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Kontrakter avsluttet av en person med dette i navnet (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "statuses",
        "in": "query",
        "schema": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "Awarded",
              "Active",
              "Expired",
              "Terminated"
            ]
          }
        },
        "required": false,
        "description": "Bare kontrakter med disse statusene, f.eks. [\"Active\"] for kontrakter som løper"
      },
      {
        "name": "state",
        "in": "query",
        "schema": {
          "type": "string",
          "enum": [
            "Draft",
            "Published"
          ]
        },
        "required": false,
        "description": "Bare utkast (Draft) eller bare publiserte kontrakter (Published)"
      },
      {
        "name": "riskLevels",
        "in": "query",
        "schema": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "VeryLow",
              "BelowAverage",
              "Average",
              "AboveAverage",
              "VeryHigh"
            ]
          }
        },
        "required": false,
        "description": "Bare kontrakter med denne risikoen"
      },
      {
        "name": "priorityLevels",
        "in": "query",
        "schema": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "VeryLow",
              "BelowAverage",
              "Average",
              "AboveAverage",
              "VeryHigh"
            ]
          }
        },
        "required": false,
        "description": "Bare kontrakter med denne prioriteten"
      },
      {
        "name": "supplierCategories",
        "in": "query",
        "schema": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "A",
              "B",
              "C",
              "D",
              "E"
            ]
          }
        },
        "required": false,
        "description": "Bare kontrakter med denne leverandørkategorien"
      },
      {
        "name": "frameworkRoles",
        "in": "query",
        "schema": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "Standalone",
              "FrameworkSupplierContract",
              "CallOff"
            ]
          }
        },
        "required": false,
        "description": "Enkeltkontrakt, rammeavtale eller avrop"
      },
      {
        "name": "currencies",
        "in": "query",
        "schema": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "required": false,
        "description": "Bare kontrakter i disse valutaene, f.eks. [\"NOK\"]"
      },
      {
        "name": "startDateFrom",
        "in": "query",
        "schema": {
          "type": "string",
          "format": "date"
        },
        "required": false,
        "description": "Bare kontrakter med startdato lik eller etter/over denne (YYYY-MM-DD)"
      },
      {
        "name": "startDateTo",
        "in": "query",
        "schema": {
          "type": "string",
          "format": "date"
        },
        "required": false,
        "description": "Bare kontrakter med startdato lik eller før/under denne (YYYY-MM-DD)"
      },
      {
        "name": "endDateFrom",
        "in": "query",
        "schema": {
          "type": "string",
          "format": "date"
        },
        "required": false,
        "description": "Bare kontrakter med sluttdato lik eller etter/over denne (YYYY-MM-DD)"
      },
      {
        "name": "endDateTo",
        "in": "query",
        "schema": {
          "type": "string",
          "format": "date"
        },
        "required": false,
        "description": "Bare kontrakter med sluttdato lik eller før/under denne (YYYY-MM-DD)"
      },
      {
        "name": "renewalDateFrom",
        "in": "query",
        "schema": {
          "type": "string",
          "format": "date"
        },
        "required": false,
        "description": "Bare kontrakter med fornyelsesdato lik eller etter/over denne (YYYY-MM-DD)"
      },
      {
        "name": "renewalDateTo",
        "in": "query",
        "schema": {
          "type": "string",
          "format": "date"
        },
        "required": false,
        "description": "Bare kontrakter med fornyelsesdato lik eller før/under denne (YYYY-MM-DD)"
      },
      {
        "name": "terminationDateFrom",
        "in": "query",
        "schema": {
          "type": "string",
          "format": "date"
        },
        "required": false,
        "description": "Bare kontrakter med oppsigelsesdato lik eller etter/over denne (YYYY-MM-DD)"
      },
      {
        "name": "terminationDateTo",
        "in": "query",
        "schema": {
          "type": "string",
          "format": "date"
        },
        "required": false,
        "description": "Bare kontrakter med oppsigelsesdato lik eller før/under denne (YYYY-MM-DD)"
      },
      {
        "name": "createdAtFrom",
        "in": "query",
        "schema": {
          "type": "string",
          "format": "date"
        },
        "required": false,
        "description": "Bare kontrakter med opprettelsesdato lik eller etter/over denne (YYYY-MM-DD)"
      },
      {
        "name": "createdAtTo",
        "in": "query",
        "schema": {
          "type": "string",
          "format": "date"
        },
        "required": false,
        "description": "Bare kontrakter med opprettelsesdato lik eller før/under denne (YYYY-MM-DD)"
      },
      {
        "name": "estimatedValueFrom",
        "in": "query",
        "schema": {
          "type": "integer"
        },
        "required": false,
        "description": "Bare kontrakter med estimert verdi («Estimert verdi» i kontraktslista, det som menes med kontraktens verdi) lik eller etter/over denne"
      },
      {
        "name": "estimatedValueTo",
        "in": "query",
        "schema": {
          "type": "integer"
        },
        "required": false,
        "description": "Bare kontrakter med estimert verdi («Estimert verdi» i kontraktslista, det som menes med kontraktens verdi) lik eller før/under denne"
      },
      {
        "name": "totalPriceFrom",
        "in": "query",
        "schema": {
          "type": "integer"
        },
        "required": false,
        "description": "Bare kontrakter med totalpris («Totalpris» i kontraktslista) lik eller etter/over denne"
      },
      {
        "name": "totalPriceTo",
        "in": "query",
        "schema": {
          "type": "integer"
        },
        "required": false,
        "description": "Bare kontrakter med totalpris («Totalpris» i kontraktslista) lik eller før/under denne"
      },
      {
        "name": "pricePerMonthFrom",
        "in": "query",
        "schema": {
          "type": "integer"
        },
        "required": false,
        "description": "Bare kontrakter med pris per måned lik eller etter/over denne"
      },
      {
        "name": "pricePerMonthTo",
        "in": "query",
        "schema": {
          "type": "integer"
        },
        "required": false,
        "description": "Bare kontrakter med pris per måned lik eller før/under denne"
      },
      {
        "name": "pricePerYearFrom",
        "in": "query",
        "schema": {
          "type": "integer"
        },
        "required": false,
        "description": "Bare kontrakter med pris per år lik eller etter/over denne"
      },
      {
        "name": "pricePerYearTo",
        "in": "query",
        "schema": {
          "type": "integer"
        },
        "required": false,
        "description": "Bare kontrakter med pris per år lik eller før/under denne"
      },
      {
        "name": "totalLiabilityFrom",
        "in": "query",
        "schema": {
          "type": "integer"
        },
        "required": false,
        "description": "Bare kontrakter med totalt ansvar («Totalt ansvar» i kontraktslista, ikke kontraktens verdi) lik eller etter/over denne"
      },
      {
        "name": "totalLiabilityTo",
        "in": "query",
        "schema": {
          "type": "integer"
        },
        "required": false,
        "description": "Bare kontrakter med totalt ansvar («Totalt ansvar» i kontraktslista, ikke kontraktens verdi) lik eller før/under denne"
      },
      {
        "name": "customFieldSearch",
        "in": "query",
        "schema": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "fieldId": {
                "type": "string"
              },
              "searchTerm": {
                "type": "string"
              }
            },
            "required": [
              "fieldId",
              "searchTerm"
            ]
          }
        },
        "required": false,
        "description": "Kontrakter der et av organisasjonens egne kontraktsfelt har denne teksten. fieldId fra lista over egne kontraktsfelt i systemmeldingen"
      },
      {
        "name": "customFieldSelect",
        "in": "query",
        "schema": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "fieldId": {
                "type": "string"
              },
              "selected": {
                "type": "boolean"
              }
            },
            "required": [
              "fieldId",
              "selected"
            ]
          }
        },
        "required": false,
        "description": "Kontrakter der et eget ja/nei-felt er ja (true) eller nei (false). fieldId fra lista over egne kontraktsfelt i systemmeldingen"
      },
      {
        "name": "limit",
        "in": "query",
        "schema": {
          "type": "integer"
        },
        "required": false
      },
      {
        "name": "skip",
        "in": "query",
        "schema": {
          "type": "integer"
        },
        "required": false,
        "description": "Antall kontrakter å hoppe over — bruk sammen med limit for å hente neste side"
      }
    ]
  },
  {
    "toolName": "getContract",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Henter detaljer for én kontrakt.",
    "entityKind": "contract",
    "params": [
      {
        "name": "contractId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "listContractMessages",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Henter meldinger (dialog) på en kontrakt.",
    "params": [
      {
        "name": "contractId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "getMe",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Henter den innloggede brukeren (navn, roller, organisasjoner).",
    "entityKind": "me",
    "params": []
  },
  {
    "toolName": "getProjects",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Lister prosjekter. Kan filtreres på navn og status.",
    "entityKind": "project",
    "params": [
      {
        "name": "name",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "status",
        "in": "query",
        "required": false,
        "description": "Filtrer på status, kommaseparert: NotStarted, Ongoing, Ended.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "limit",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "skip",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "withCount",
        "in": "query",
        "required": false,
        "description": "Also count every project the filters leave that the viewer may see.",
        "schema": {
          "type": "boolean"
        }
      }
    ]
  },
  {
    "toolName": "getProject",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Henter detaljer for ett prosjekt.",
    "entityKind": "project",
    "params": [
      {
        "name": "projectId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "listNeeds",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Lister behov (meld inn behov).",
    "entityKind": "need",
    "params": [
      {
        "name": "status",
        "in": "query",
        "required": false,
        "description": "Filtrer på status, kommaseparert: DRAFT, REPORTED, SENT_BACK, APPROVED, PLANNED, FRAMEWORK_RECOMMENDED, PROCUREMENT_CREATED, UNDER_PROCUREMENT, UNDER_CALL_OFF, COMPLETED, REJECTED, WITHDRAWN.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "waiting",
        "in": "query",
        "required": false,
        "description": "The needs waiting for innkjøp, by the same rule as the home page: Queue is what the caller may take, oldest first; Mine is what the caller is responsible for with nothing started. Status is ignored.",
        "schema": {
          "type": "string",
          "enum": [
            "Queue",
            "Mine"
          ]
        }
      },
      {
        "name": "figure",
        "in": "query",
        "required": false,
        "description": "The needs behind a figure on Oversikt › Behov, by the same rule as the figure, for the period in `from` and `to`, narrowed to `status` and `department` when given. The queue figure is listed with `waiting=Queue`.",
        "schema": {
          "type": "string",
          "enum": [
            "REPORTED",
            "MEDIAN_QUEUE_DAYS",
            "WITH_PROCURER_NOTHING_STARTED",
            "DELIVERY_SOON",
            "BECAME_PROCUREMENT"
          ]
        }
      },
      {
        "name": "from",
        "in": "query",
        "required": false,
        "description": "First day of the figure's period.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "to",
        "in": "query",
        "required": false,
        "description": "Last day of the figure's period.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "department",
        "in": "query",
        "required": false,
        "description": "With figure: only the figure's needs in this department.",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "responsible",
        "in": "query",
        "required": false,
        "description": "With waiting=Mine: the responsible buyer whose needs to list instead of the caller's.",
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "getNeed",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Henter detaljer for ett behov.",
    "entityKind": "need",
    "params": [
      {
        "name": "needId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "listMyNotifications",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Henter dine varsler.",
    "entityKind": "notification",
    "params": [
      {
        "name": "limit",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "offset",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "unseen",
        "in": "query",
        "required": false,
        "schema": {
          "type": "boolean"
        }
      },
      {
        "name": "unread",
        "in": "query",
        "required": false,
        "description": "Only unread notifications. Unlike unseen, opening the list does not clear them. Without a limit, all are returned.",
        "schema": {
          "type": "boolean"
        }
      }
    ]
  },
  {
    "toolName": "answerSeQuestion",
    "method": "PATCH",
    "riskTier": "reversible",
    "module": "assistant",
    "description": "Svarer på et spørsmål fra en leverandør (privat svar).",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "questionId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "seQuestionPatchDto",
        "in": "body",
        "required": true,
        "schema": {
          "type": "object",
          "properties": {
            "answer": {
              "type": "string"
            },
            "attachments": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "documentId": {
                    "type": "string"
                  },
                  "source": {
                    "type": "string",
                    "enum": [
                      "REQUEST",
                      "OFFER",
                      "UPLOAD"
                    ]
                  }
                },
                "required": [
                  "documentId",
                  "source"
                ],
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    ]
  },
  {
    "toolName": "awardSourcingEvent",
    "method": "POST",
    "riskTier": "binding_statutory",
    "module": "assistant",
    "description": "Tildeler anskaffelsen til ett eller flere vinnende tilbud.",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "awardSourcingEventRequest",
        "in": "body",
        "required": true,
        "schema": {
          "type": "object",
          "properties": {
            "winningBidIds": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "internalNote": {
              "type": "string",
              "nullable": true
            },
            "eventValue": {
              "allOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": {
                      "type": "number",
                      "nullable": true,
                      "format": "double"
                    },
                    "currency": {
                      "type": "string",
                      "enum": [
                        "NOK",
                        "USD",
                        "EUR",
                        "DKK"
                      ]
                    }
                  },
                  "required": [
                    "currency"
                  ],
                  "additionalProperties": false
                }
              ],
              "nullable": true
            },
            "dialogueDepartureJustification": {
              "type": "string",
              "nullable": true
            },
            "juryDepartureJustification": {
              "type": "string",
              "nullable": true
            },
            "rankingDepartureJustification": {
              "type": "string",
              "nullable": true
            },
            "proceedDespiteFlaggedEntries": {
              "type": "boolean"
            },
            "standstillDays": {
              "type": "integer",
              "nullable": true,
              "format": "int32"
            },
            "standstillExemption": {
              "allOf": [
                {
                  "type": "string",
                  "enum": [
                    "SOLE_CONCERNED_SUPPLIER",
                    "FRAMEWORK_AGREEMENT_CALL_OFF"
                  ]
                }
              ],
              "nullable": true
            },
            "winnerDocumentationCheck": {
              "allOf": [
                {
                  "type": "object",
                  "properties": {
                    "note": {
                      "type": "string",
                      "nullable": true
                    }
                  },
                  "additionalProperties": false
                }
              ],
              "nullable": true
            },
            "relativeAdvantages": {
              "type": "string",
              "nullable": true
            }
          },
          "additionalProperties": false,
          "required": [
            "winningBidIds"
          ]
        }
      }
    ]
  },
  {
    "toolName": "createSourcingEvent",
    "method": "POST",
    "riskTier": "reversible",
    "module": "assistant",
    "description": "Oppretter en ny anskaffelse (utkast).",
    "params": [
      {
        "name": "title",
        "in": "body",
        "schema": {
          "type": "string"
        },
        "required": true,
        "description": "Anskaffelsens tittel — bruk tom streng hvis brukeren ikke har oppgitt noen"
      },
      {
        "name": "homeDepartment",
        "in": "body",
        "schema": {
          "type": "string",
          "minLength": 1
        },
        "required": true,
        "description": "NAVNET på avdelingen anskaffelsen skal ligge under (ikke en id). Systemmeldingen lister avdelingene du kan opprette i. Spør brukeren hvis det er flere og brukeren ikke har sagt hvilken."
      },
      {
        "name": "fieldSources",
        "in": "body",
        "required": false,
        "schema": {
          "type": "array",
          "nullable": true,
          "description": "Kilden til tittelen du gir anskaffelsen: én oppføring med path title. source.kind sier hvor verdien kom fra: USER_ANSWER (brukerens svar), UPLOADED_DOCUMENT (krever fileName og page eller section, gjerne også documentId), REQUIREMENT_LIBRARY (krever libraryElementId fra listLibraryElements), EARLIER_PROCUREMENT (krever sourcingEventId), EARLIER_CONTRACT (krever contractId), NEED (krever needId), PRODUCT_RULES (gjerne rule) eller ASSISTANT_SUGGESTION. Mangler en kilde det den krever, lagres feltets standardkilde. En kilde gjelder bare felt denne skrivingen endrer.",
          "items": {
            "type": "object",
            "properties": {
              "path": {
                "type": "string"
              },
              "source": {
                "type": "object",
                "properties": {
                  "kind": {
                    "type": "string",
                    "enum": [
                      "USER_ANSWER",
                      "UPLOADED_DOCUMENT",
                      "REQUIREMENT_LIBRARY",
                      "EARLIER_PROCUREMENT",
                      "EARLIER_CONTRACT",
                      "NEED",
                      "PRODUCT_RULES",
                      "ASSISTANT_SUGGESTION"
                    ]
                  },
                  "documentId": {
                    "type": "string",
                    "nullable": true
                  },
                  "fileName": {
                    "type": "string",
                    "nullable": true
                  },
                  "page": {
                    "type": "integer",
                    "nullable": true,
                    "format": "int32"
                  },
                  "section": {
                    "type": "string",
                    "nullable": true
                  },
                  "libraryElementId": {
                    "type": "string",
                    "nullable": true
                  },
                  "libraryElementTitle": {
                    "type": "string",
                    "nullable": true
                  },
                  "sourcingEventId": {
                    "type": "string",
                    "nullable": true
                  },
                  "contractId": {
                    "type": "string",
                    "nullable": true
                  },
                  "needId": {
                    "type": "string",
                    "nullable": true
                  },
                  "title": {
                    "type": "string",
                    "nullable": true
                  },
                  "rule": {
                    "type": "string",
                    "nullable": true
                  }
                },
                "required": [
                  "kind"
                ],
                "additionalProperties": false
              }
            },
            "required": [
              "path",
              "source"
            ],
            "additionalProperties": false
          }
        }
      }
    ]
  },
  {
    "toolName": "updateSourcingEvent",
    "method": "PUT",
    "riskTier": "reversible",
    "module": "assistant",
    "description": "Fyller inn eller endrer feltene i anskaffelsens steg: grunninformasjon, klassifisering, prosedyre, kvalifikasjon, tildelingskriterier, minstekrav og, for en privat konkurranse, detaljer og inviterte leverandører. Send bare feltene som skal endres. Et felt satt til null tømmes, så bruk null bare når brukeren ber om å tømme feltet. En liste erstattes i sin helhet, så hent anskaffelsen med getSourcingEvent først og send hele lista med endringen. Skal flere steg fylles ut, sender du alle i ett kall, så lagres de samlet. En anskaffelse har nøyaktig én tildelingsmodell: enten eventData.awardCriteria.lowestPrice eller eventData.awardCriteria.bestPriceQualityRatio, aldri begge. Pris er et kriterium (type PRICE) inne i bestPriceQualityRatio, ikke laveste pris. Systemet sjekker forslaget før brukeren ser det.",
    "entityKind": "v2Event",
    "checksBeforeConfirm": true,
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "sourcingEventPatchDto",
        "in": "body",
        "required": true,
        "schema": {
          "type": "object",
          "properties": {
            "eventData": {
              "type": "object",
              "properties": {
                "title": {
                  "type": "string"
                },
                "description": {
                  "type": "string",
                  "nullable": true
                },
                "bidSubmissionDeadline": {
                  "type": "string",
                  "nullable": true,
                  "format": "date-time"
                },
                "bidSubmissionDeadlineConfirmed": {
                  "type": "boolean",
                  "nullable": true
                },
                "tenderDeadlineAgreedWithCandidates": {
                  "type": "boolean",
                  "nullable": true
                },
                "requestDeadline": {
                  "type": "string",
                  "nullable": true,
                  "format": "date-time"
                },
                "requestDeadlineConfirmed": {
                  "type": "boolean",
                  "nullable": true
                },
                "milestonePlan": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "announcementDate": {
                          "type": "string",
                          "nullable": true,
                          "format": "date-time"
                        },
                        "questionDaysBeforeBid": {
                          "type": "integer",
                          "nullable": true,
                          "format": "int32"
                        },
                        "tenderPeriodOffsetDays": {
                          "type": "integer",
                          "nullable": true,
                          "format": "int32"
                        },
                        "evaluationOffsetDays": {
                          "type": "integer",
                          "nullable": true,
                          "format": "int32"
                        },
                        "awardOffsetDays": {
                          "type": "integer",
                          "nullable": true,
                          "format": "int32"
                        },
                        "contractSigningOffsetDays": {
                          "type": "integer",
                          "nullable": true,
                          "format": "int32"
                        }
                      },
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                },
                "contractDuration": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "type": "string",
                          "enum": [
                            "FIXED_DATES",
                            "PERIOD_BASED",
                            "OPEN_ENDED"
                          ]
                        },
                        "startDate": {
                          "type": "string",
                          "nullable": true,
                          "format": "date"
                        },
                        "endDate": {
                          "type": "string",
                          "nullable": true,
                          "format": "date"
                        },
                        "periodMonths": {
                          "type": "integer",
                          "nullable": true,
                          "format": "int32"
                        }
                      },
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                },
                "awardCriteria": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "lowestPrice": {
                          "allOf": [
                            {
                              "type": "object",
                              "properties": {
                                "selected": {
                                  "type": "boolean"
                                }
                              },
                              "required": [],
                              "additionalProperties": false
                            }
                          ],
                          "nullable": true
                        },
                        "bestPriceQualityRatio": {
                          "allOf": [
                            {
                              "type": "object",
                              "properties": {
                                "criteria": {
                                  "type": "array",
                                  "items": {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "type": "string",
                                        "enum": [
                                          "PRICE",
                                          "COST",
                                          "QUALITY",
                                          "QUALITY_ENVIRONMENTAL_CRITERIA",
                                          "QUALITY_ENVIRONMENTAL_SPECIFICATION",
                                          "QUALITY_ENVIRONMENTAL_EXEMPT_INSIGNIFICANT",
                                          "QUALITY_ENVIRONMENTAL_EXEMPT_CRITICAL_INTEREST",
                                          "QUALITY_ENVIRONMENTAL_EXEMPT_NATIONAL_MINIMUM"
                                        ]
                                      },
                                      "id": {
                                        "type": "string"
                                      },
                                      "name": {
                                        "type": "string",
                                        "nullable": true
                                      },
                                      "description": {
                                        "type": "string"
                                      },
                                      "weight": {
                                        "allOf": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "type": {
                                                "type": "string",
                                                "enum": [
                                                  "PERCENTAGE",
                                                  "DECIMAL",
                                                  "POINTS_OF_RANGE",
                                                  "ORDER_OF_IMPORTANCE"
                                                ]
                                              },
                                              "number": {
                                                "type": "number",
                                                "format": "double"
                                              }
                                            },
                                            "required": [],
                                            "additionalProperties": false
                                          }
                                        ],
                                        "nullable": true
                                      },
                                      "commonRationale": {
                                        "type": "string",
                                        "nullable": true
                                      },
                                      "subCriteria": {
                                        "type": "array",
                                        "items": {
                                          "type": "object",
                                          "properties": {
                                            "id": {
                                              "type": "string"
                                            },
                                            "name": {
                                              "type": "string",
                                              "nullable": true
                                            },
                                            "description": {
                                              "type": "string"
                                            },
                                            "weight": {
                                              "allOf": [
                                                {
                                                  "type": "object",
                                                  "properties": {
                                                    "type": {
                                                      "type": "string",
                                                      "enum": [
                                                        "PERCENTAGE",
                                                        "DECIMAL",
                                                        "POINTS_OF_RANGE",
                                                        "ORDER_OF_IMPORTANCE"
                                                      ]
                                                    },
                                                    "number": {
                                                      "type": "number",
                                                      "format": "double"
                                                    }
                                                  },
                                                  "required": [],
                                                  "additionalProperties": false
                                                }
                                              ],
                                              "nullable": true
                                            },
                                            "answerFormat": {
                                              "type": "string",
                                              "enum": [
                                                "FREE_TEXT",
                                                "DOCUMENT",
                                                "NUMBER",
                                                "YES_NO_PARTIAL"
                                              ]
                                            },
                                            "requiresDocumentation": {
                                              "type": "boolean"
                                            }
                                          },
                                          "additionalProperties": false
                                        }
                                      }
                                    },
                                    "additionalProperties": false
                                  }
                                },
                                "environmentWeightingJustification": {
                                  "type": "string",
                                  "nullable": true
                                },
                                "environmentWeightingJustificationIsStandardText": {
                                  "type": "boolean"
                                },
                                "unweightedReason": {
                                  "type": "string",
                                  "nullable": true
                                }
                              },
                              "additionalProperties": false
                            }
                          ],
                          "nullable": true
                        }
                      },
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                },
                "selectionCriteria": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "type": {
                        "type": "string",
                        "enum": [
                          "ECONOMIC_FINANCIAL",
                          "TECHNICAL_PROFESSIONAL",
                          "SUITABILITY",
                          "QUALITY_ENVIRONMENT",
                          "OTHER"
                        ]
                      },
                      "name": {
                        "type": "string"
                      },
                      "description": {
                        "type": "string"
                      },
                      "requiresEvidence": {
                        "type": "boolean"
                      }
                    },
                    "required": [],
                    "additionalProperties": false
                  }
                },
                "minimumRequirements": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "string"
                      },
                      "title": {
                        "type": "string"
                      },
                      "description": {
                        "type": "string"
                      },
                      "responseType": {
                        "type": "string",
                        "enum": [
                          "YES_NO",
                          "YES_NO_COMMENT",
                          "YES_NO_DOCUMENT"
                        ]
                      }
                    },
                    "required": [],
                    "additionalProperties": false
                  }
                },
                "placeOfPerformance": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "countryCode": {
                          "type": "string",
                          "nullable": true
                        },
                        "countrySubdivision": {
                          "type": "string",
                          "nullable": true
                        },
                        "servicesOther": {
                          "type": "string",
                          "nullable": true
                        }
                      },
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                },
                "options": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "hasOptions": {
                          "type": "boolean"
                        },
                        "extensions": {
                          "type": "array",
                          "items": {
                            "type": "object",
                            "properties": {
                              "duration": {
                                "type": "integer",
                                "format": "int32"
                              },
                              "unit": {
                                "type": "string",
                                "enum": [
                                  "YEARS",
                                  "MONTHS"
                                ]
                              },
                              "exerciseDeadlineMonths": {
                                "type": "integer",
                                "format": "int32"
                              }
                            },
                            "required": [],
                            "additionalProperties": false
                          }
                        }
                      },
                      "required": [],
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                },
                "collectSupplierPrice": {
                  "type": "boolean"
                },
                "priceModel": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "proportional": {
                          "allOf": [
                            {
                              "type": "object",
                              "properties": {
                                "selected": {
                                  "type": "boolean"
                                }
                              },
                              "required": [],
                              "additionalProperties": false
                            }
                          ],
                          "nullable": true
                        },
                        "linear": {
                          "allOf": [
                            {
                              "type": "object",
                              "properties": {
                                "selected": {
                                  "type": "boolean"
                                }
                              },
                              "required": [],
                              "additionalProperties": false
                            }
                          ],
                          "nullable": true
                        },
                        "hybrid": {
                          "allOf": [
                            {
                              "type": "object",
                              "properties": {
                                "breakpointPercent": {
                                  "type": "integer",
                                  "format": "int32"
                                }
                              },
                              "required": [],
                              "additionalProperties": false
                            }
                          ],
                          "nullable": true
                        }
                      },
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                },
                "documents": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "string"
                      },
                      "name": {
                        "type": "string"
                      },
                      "mimeType": {
                        "type": "string"
                      },
                      "fileExtension": {
                        "type": "string"
                      },
                      "size": {
                        "type": "integer",
                        "format": "int64"
                      },
                      "uploadedAt": {
                        "type": "string",
                        "format": "date-time"
                      },
                      "uploadedBy": {
                        "type": "object",
                        "properties": {
                          "id": {
                            "type": "string"
                          },
                          "firstName": {
                            "type": "string",
                            "nullable": true
                          },
                          "lastName": {
                            "type": "string",
                            "nullable": true
                          },
                          "email": {
                            "type": "string"
                          },
                          "corporateTitle": {
                            "type": "string",
                            "nullable": true
                          },
                          "phoneNumber": {
                            "allOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "callingCode": {
                                    "type": "object",
                                    "properties": {
                                      "countryAlpha3Code": {
                                        "type": "string"
                                      },
                                      "countryName": {
                                        "type": "string"
                                      },
                                      "value": {
                                        "type": "string"
                                      }
                                    },
                                    "required": [
                                      "countryAlpha3Code",
                                      "countryName",
                                      "value"
                                    ],
                                    "additionalProperties": false
                                  },
                                  "number": {
                                    "type": "string"
                                  }
                                },
                                "required": [
                                  "callingCode",
                                  "number"
                                ],
                                "additionalProperties": false
                              }
                            ],
                            "nullable": true
                          }
                        },
                        "required": [
                          "id",
                          "email"
                        ],
                        "additionalProperties": false
                      },
                      "s3Key": {
                        "type": "string"
                      },
                      "fromUploadId": {
                        "type": "string"
                      },
                      "tags": {
                        "type": "array",
                        "items": {
                          "type": "string"
                        }
                      },
                      "fencyContentStatus": {
                        "allOf": [
                          {
                            "type": "string",
                            "enum": [
                              "EMPTY",
                              "SYNCHRONIZING",
                              "SYNCHRONIZED",
                              "SYNCHRONIZATION_ERROR"
                            ]
                          }
                        ],
                        "nullable": true
                      },
                      "category": {
                        "allOf": [
                          {
                            "type": "string",
                            "enum": [
                              "COMPETITION_BASIS",
                              "PRICE_SHEET",
                              "REQUIREMENTS_SPEC",
                              "CONTRACT",
                              "OTHER"
                            ]
                          }
                        ],
                        "nullable": true
                      }
                    },
                    "required": [
                      "id",
                      "name",
                      "mimeType",
                      "fileExtension",
                      "size",
                      "uploadedAt",
                      "uploadedBy",
                      "s3Key",
                      "fromUploadId",
                      "tags"
                    ],
                    "additionalProperties": false
                  }
                },
                "projects": {
                  "type": "array",
                  "nullable": true,
                  "items": {
                    "type": "string"
                  }
                },
                "referenceId": {
                  "type": "string",
                  "nullable": true
                },
                "includeProducts": {
                  "type": "boolean",
                  "nullable": true
                },
                "includeMinimumRequirements": {
                  "type": "boolean",
                  "nullable": true
                },
                "includeAwardCriteria": {
                  "type": "boolean",
                  "nullable": true
                }
              },
              "additionalProperties": false
            },
            "eventContext": {
              "type": "object",
              "properties": {
                "estimatedValue": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": {
                          "type": "number",
                          "nullable": true,
                          "format": "double"
                        },
                        "currency": {
                          "type": "string",
                          "enum": [
                            "NOK",
                            "USD",
                            "EUR",
                            "DKK"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                },
                "contractNature": {
                  "allOf": [
                    {
                      "type": "string",
                      "enum": [
                        "WORKS",
                        "SUPPLIES",
                        "SERVICES",
                        "COMBINED"
                      ]
                    }
                  ],
                  "nullable": true
                }
              },
              "additionalProperties": false
            },
            "publicContext": {
              "type": "object",
              "properties": {
                "regulation": {
                  "allOf": [
                    {
                      "type": "string",
                      "enum": [
                        "FOA",
                        "FORSYNINGSFORSKRIFTEN",
                        "KONSESJONSKONTRAKTFORSKRIFTEN"
                      ]
                    }
                  ],
                  "nullable": true
                },
                "procedureType": {
                  "allOf": [
                    {
                      "type": "string",
                      "enum": [
                        "OPEN",
                        "OPEN_TENDER_COMPETITION",
                        "RESTRICTED",
                        "RESTRICTED_TENDER_COMPETITION",
                        "NEGOTIATED_WITH_PRIOR_CALL",
                        "NEGOTIATED_WITHOUT_PRIOR_CALL",
                        "COMPETITIVE_DIALOGUE",
                        "INNOVATION_PARTNERSHIP",
                        "COMPETITIVE_NEGOTIATION",
                        "OTHER_SINGLE_STAGE",
                        "DYNAMIC_PURCHASING_SYSTEM",
                        "DPS_COMPETITION",
                        "QUALIFICATION_SCHEME",
                        "WITHOUT_COMPETITION",
                        "DESIGN_CONTEST_OPEN",
                        "DESIGN_CONTEST_RESTRICTED"
                      ]
                    }
                  ],
                  "nullable": true
                },
                "buyerLegalType": {
                  "allOf": [
                    {
                      "type": "string",
                      "enum": [
                        "PUBLIC_LAW_BODY",
                        "PUBLIC_LAW_BODY_CENTRAL",
                        "PUBLIC_LAW_BODY_REGIONAL",
                        "PUBLIC_LAW_BODY_LOCAL",
                        "CENTRAL_GOVERNMENT",
                        "DEFENCE_CONTRACTOR",
                        "EU_INSTITUTION",
                        "EU_INTERNATIONAL_ORG",
                        "GROUP_OF_PUBLIC_AUTHORITIES",
                        "INTERNATIONAL_ORG",
                        "MUNICIPALITY",
                        "ORGANISATION_PART",
                        "ORGANISATION_PART_CENTRAL",
                        "ORGANISATION_PART_REGIONAL",
                        "ORGANISATION_PART_LOCAL",
                        "PUBLIC_UNDERTAKING",
                        "PUBLIC_UNDERTAKING_CENTRAL",
                        "PUBLIC_UNDERTAKING_REGIONAL",
                        "PUBLIC_UNDERTAKING_LOCAL",
                        "COUNTY",
                        "REGIONAL_OR_LOCAL",
                        "SPECIAL_RIGHTS_ENTITY",
                        "PRIVATE"
                      ]
                    }
                  ],
                  "nullable": true
                },
                "utilityActivity": {
                  "allOf": [
                    {
                      "type": "string",
                      "enum": [
                        "AIRPORT",
                        "ELECTRICITY",
                        "GAS_HEAT",
                        "GAS_OIL",
                        "PORT",
                        "POST",
                        "RAIL",
                        "SOLID_FUEL",
                        "URBAN_TRANSPORT",
                        "WATER"
                      ]
                    }
                  ],
                  "nullable": true
                },
                "foaPart": {
                  "allOf": [
                    {
                      "type": "string",
                      "enum": [
                        "OUTSIDE_FOA",
                        "PART_I",
                        "PART_II",
                        "PART_III",
                        "PART_IV"
                      ]
                    }
                  ],
                  "nullable": true
                },
                "cpvCodes": {
                  "type": "array",
                  "items": {
                    "type": "string"
                  }
                },
                "frameworkAgreement": {
                  "allOf": [
                    {
                      "type": "string",
                      "enum": [
                        "NONE",
                        "WITH_REOPENING",
                        "WITHOUT_REOPENING",
                        "MIXED"
                      ]
                    }
                  ],
                  "nullable": true
                },
                "frameworkMaxParticipants": {
                  "type": "integer",
                  "nullable": true,
                  "format": "int32"
                },
                "frameworkMaximumValue": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": {
                          "type": "number",
                          "nullable": true,
                          "format": "double"
                        },
                        "currency": {
                          "type": "string",
                          "enum": [
                            "NOK",
                            "USD",
                            "EUR",
                            "DKK"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                },
                "dynamicPurchasingSystem": {
                  "allOf": [
                    {
                      "type": "string",
                      "enum": [
                        "NONE",
                        "ONLY_LISTED_BUYERS",
                        "ALSO_UNLISTED_BUYERS"
                      ]
                    }
                  ],
                  "nullable": true
                },
                "electronicAuction": {
                  "type": "boolean",
                  "nullable": true
                },
                "gpaCoverage": {
                  "type": "boolean",
                  "nullable": true
                },
                "euFunded": {
                  "type": "boolean",
                  "nullable": true
                },
                "reservedParticipation": {
                  "allOf": [
                    {
                      "type": "string",
                      "enum": [
                        "NONE",
                        "SHELTERED_WORKSHOP",
                        "PUBLIC_SERVICE_MISSION"
                      ]
                    }
                  ],
                  "nullable": true
                },
                "reservedExecution": {
                  "allOf": [
                    {
                      "type": "string",
                      "enum": [
                        "NONE",
                        "SHELTERED_EMPLOYMENT",
                        "NOT_KNOWN"
                      ]
                    }
                  ],
                  "nullable": true
                },
                "acceleratedProcedure": {
                  "type": "boolean",
                  "nullable": true
                },
                "acceleratedJustification": {
                  "type": "string",
                  "nullable": true
                },
                "shortRequestDeadlineJustification": {
                  "type": "string",
                  "nullable": true
                },
                "eFormsNoticeData": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "electronicOrdering": {
                          "type": "boolean",
                          "nullable": true
                        },
                        "electronicInvoicing": {
                          "type": "boolean",
                          "nullable": true
                        },
                        "electronicPayment": {
                          "type": "boolean",
                          "nullable": true
                        },
                        "submissionElectronic": {
                          "type": "boolean",
                          "nullable": true
                        },
                        "submissionLanguages": {
                          "type": "array",
                          "items": {
                            "type": "string"
                          }
                        },
                        "electronicCatalogue": {
                          "type": "boolean",
                          "nullable": true
                        },
                        "documentsRestricted": {
                          "type": "boolean",
                          "nullable": true
                        },
                        "exclusionGroundsSource": {
                          "type": "string",
                          "nullable": true
                        },
                        "selectionCriteriaSource": {
                          "type": "string",
                          "nullable": true
                        },
                        "variants": {
                          "type": "boolean",
                          "nullable": true
                        },
                        "tenderValidityMonths": {
                          "type": "integer",
                          "nullable": true,
                          "format": "int32"
                        },
                        "publicOpeningDate": {
                          "type": "string",
                          "nullable": true,
                          "format": "date-time"
                        },
                        "publicOpeningPlace": {
                          "type": "string",
                          "nullable": true
                        },
                        "documentsUrl": {
                          "type": "string",
                          "nullable": true
                        },
                        "reviewDeadlineDescription": {
                          "type": "string",
                          "nullable": true
                        },
                        "submissionUrl": {
                          "type": "string",
                          "nullable": true
                        }
                      },
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                },
                "activeExclusionGroundIds": {
                  "type": "array",
                  "items": {
                    "type": "string"
                  }
                },
                "candidateLimits": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "minCandidates": {
                          "type": "integer",
                          "format": "int32"
                        },
                        "maxCandidates": {
                          "type": "integer",
                          "nullable": true,
                          "format": "int32"
                        },
                        "selectionCriteria": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                },
                "procedureJustification": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "ground": {
                          "type": "string",
                          "enum": [
                            "NEEDS_ADAPTATION_OF_AVAILABLE_SOLUTIONS",
                            "DESIGN_OR_INNOVATION",
                            "NATURE_COMPLEXITY_LEGAL_OR_FINANCIAL_CIRCUMSTANCES",
                            "SPECIFICATIONS_CANNOT_BE_ESTABLISHED_PRECISELY",
                            "ONLY_UNACCEPTABLE_TENDERS_IN_PRIOR_COMPETITION"
                          ]
                        },
                        "rationale": {
                          "type": "string"
                        }
                      },
                      "required": [],
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                },
                "frameworkOverFourYearsJustification": {
                  "type": "string",
                  "nullable": true
                },
                "qualificationSchemeRules": {
                  "type": "string",
                  "nullable": true
                },
                "qualificationSchemeCategories": {
                  "type": "array",
                  "items": {
                    "type": "string"
                  }
                },
                "noCompetitionJustification": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "condition": {
                          "type": "string",
                          "enum": [
                            "NEGOTIATED_PROCEDURE_IMPOSSIBLE",
                            "UNIQUE_ARTISTIC_WORK",
                            "TECHNICAL_REASONS",
                            "EXCLUSIVE_RIGHTS",
                            "ADDITIONAL_DELIVERIES",
                            "REPETITION_OF_SIMILAR_WORKS",
                            "COMMODITY_MARKET",
                            "BARGAIN_PURCHASE",
                            "WINDING_UP_TERMS",
                            "DESIGN_CONTEST_WINNER"
                          ]
                        },
                        "rationale": {
                          "type": "string"
                        },
                        "originalContractId": {
                          "type": "string",
                          "nullable": true
                        },
                        "repetitionForeseenInOriginalDocuments": {
                          "type": "boolean",
                          "nullable": true
                        },
                        "negotiationImpossibleCase": {
                          "allOf": [
                            {
                              "type": "string",
                              "enum": [
                                "ONLY_UNACCEPTABLE_TENDERS",
                                "NO_SUITABLE_TENDERS",
                                "RESEARCH_AND_DEVELOPMENT",
                                "DESIGN_CONTEST_WINNERS",
                                "EXTREME_URGENCY",
                                "COVER_PURCHASE"
                              ]
                            }
                          ],
                          "nullable": true
                        },
                        "windingUpCase": {
                          "allOf": [
                            {
                              "type": "string",
                              "enum": [
                                "SUPPLIER_STOPPED_TRADING",
                                "INSOLVENCY_ADMINISTRATOR"
                              ]
                            }
                          ],
                          "nullable": true
                        }
                      },
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                },
                "negotiationWithoutNotice": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "case": {
                          "allOf": [
                            {
                              "type": "string",
                              "enum": [
                                "ONLY_UNACCEPTABLE_TENDERS",
                                "NO_SUITABLE_TENDERS",
                                "RESEARCH_AND_DEVELOPMENT",
                                "DESIGN_CONTEST_WINNERS",
                                "EXTREME_URGENCY",
                                "COVER_PURCHASE"
                              ]
                            }
                          ],
                          "nullable": true
                        },
                        "rationale": {
                          "type": "string",
                          "nullable": true
                        },
                        "precedingEventId": {
                          "type": "string",
                          "nullable": true
                        },
                        "invitedOrganizationIds": {
                          "type": "array",
                          "items": {
                            "type": "string"
                          }
                        },
                        "unchangedBasisConfirmed": {
                          "type": "boolean",
                          "nullable": true
                        }
                      },
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                },
                "designContest": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "leadsToServiceContract": {
                          "type": "boolean",
                          "nullable": true
                        },
                        "juryDecisionBinding": {
                          "type": "boolean",
                          "nullable": true
                        },
                        "prizes": {
                          "type": "array",
                          "items": {
                            "type": "object",
                            "properties": {
                              "description": {
                                "type": "string"
                              },
                              "value": {
                                "allOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": {
                                        "type": "number",
                                        "nullable": true,
                                        "format": "double"
                                      },
                                      "currency": {
                                        "type": "string",
                                        "enum": [
                                          "NOK",
                                          "USD",
                                          "EUR",
                                          "DKK"
                                        ]
                                      }
                                    },
                                    "required": [
                                      "currency"
                                    ],
                                    "additionalProperties": false
                                  }
                                ],
                                "nullable": true
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "juryCriteria": {
                          "type": "array",
                          "items": {
                            "type": "string"
                          }
                        },
                        "requiredParticipantQualification": {
                          "type": "string",
                          "nullable": true
                        },
                        "jury": {
                          "type": "array",
                          "items": {
                            "type": "object",
                            "properties": {
                              "name": {
                                "type": "string"
                              },
                              "role": {
                                "type": "string",
                                "nullable": true
                              },
                              "holdsRequiredQualification": {
                                "type": "boolean"
                              },
                              "independenceConfirmed": {
                                "type": "boolean"
                              },
                              "personId": {
                                "type": "string",
                                "nullable": true
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "climateConsideration": {
                          "allOf": [
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "type": "string",
                                  "enum": [
                                    "PRICE",
                                    "COST",
                                    "QUALITY",
                                    "QUALITY_ENVIRONMENTAL_CRITERIA",
                                    "QUALITY_ENVIRONMENTAL_SPECIFICATION",
                                    "QUALITY_ENVIRONMENTAL_EXEMPT_INSIGNIFICANT",
                                    "QUALITY_ENVIRONMENTAL_EXEMPT_CRITICAL_INTEREST",
                                    "QUALITY_ENVIRONMENTAL_EXEMPT_NATIONAL_MINIMUM"
                                  ]
                                },
                                "description": {
                                  "type": "string",
                                  "nullable": true
                                }
                              },
                              "additionalProperties": false
                            }
                          ],
                          "nullable": true
                        }
                      },
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                },
                "noNegotiationNecessary": {
                  "type": "boolean",
                  "nullable": true
                },
                "reducesInSuccessiveStages": {
                  "type": "boolean",
                  "nullable": true
                },
                "dialoguePlanned": {
                  "type": "boolean",
                  "nullable": true
                },
                "dialogueDescription": {
                  "type": "string",
                  "nullable": true
                },
                "estimatedValueBasis": {
                  "type": "string",
                  "nullable": true
                },
                "espdEnabled": {
                  "type": "boolean",
                  "nullable": true
                },
                "specialServices": {
                  "type": "boolean",
                  "nullable": true
                },
                "serviceCategory": {
                  "allOf": [
                    {
                      "type": "string",
                      "enum": [
                        "ORDINARY",
                        "SPECIAL_SERVICES",
                        "HEALTH_SOCIAL_EDUCATION"
                      ]
                    }
                  ],
                  "nullable": true
                },
                "dpsScheme": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "validFrom": {
                          "type": "string",
                          "format": "date-time"
                        },
                        "validTo": {
                          "type": "string",
                          "format": "date-time"
                        }
                      },
                      "required": [],
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                },
                "qualificationScheme": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "validFrom": {
                          "type": "string",
                          "format": "date-time"
                        },
                        "validTo": {
                          "type": "string",
                          "format": "date-time"
                        }
                      },
                      "required": [],
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                },
                "priorInformationCall": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "plannedInvitationAt": {
                          "type": "string",
                          "format": "date-time"
                        }
                      },
                      "required": [],
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                }
              },
              "additionalProperties": false
            },
            "privateContext": {
              "type": "object",
              "properties": {
                "organizationInvites": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "organizationId": {
                        "type": "string"
                      },
                      "persons": {
                        "type": "array",
                        "items": {
                          "type": "object",
                          "properties": {
                            "id": {
                              "type": "string"
                            }
                          },
                          "required": [
                            "id"
                          ],
                          "additionalProperties": false
                        }
                      },
                      "emailInvites": {
                        "type": "array",
                        "items": {
                          "type": "object",
                          "properties": {
                            "email": {
                              "type": "string"
                            },
                            "language": {
                              "type": "string",
                              "enum": [
                                "En",
                                "No"
                              ]
                            }
                          },
                          "required": [
                            "email",
                            "language"
                          ],
                          "additionalProperties": false
                        }
                      }
                    },
                    "required": [
                      "organizationId"
                    ],
                    "additionalProperties": false
                  }
                }
              },
              "required": [],
              "additionalProperties": false
            },
            "miniCompetitionContext": {
              "type": "object",
              "properties": {
                "organizationInvites": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "organizationId": {
                        "type": "string"
                      },
                      "persons": {
                        "type": "array",
                        "items": {
                          "type": "object",
                          "properties": {
                            "id": {
                              "type": "string"
                            }
                          },
                          "required": [
                            "id"
                          ],
                          "additionalProperties": false
                        }
                      },
                      "emailInvites": {
                        "type": "array",
                        "items": {
                          "type": "object",
                          "properties": {
                            "email": {
                              "type": "string"
                            },
                            "language": {
                              "type": "string",
                              "enum": [
                                "En",
                                "No"
                              ]
                            }
                          },
                          "required": [
                            "email",
                            "language"
                          ],
                          "additionalProperties": false
                        }
                      }
                    },
                    "required": [
                      "organizationId"
                    ],
                    "additionalProperties": false
                  }
                },
                "estimatedValue": {
                  "allOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": {
                          "type": "number",
                          "nullable": true,
                          "format": "double"
                        },
                        "currency": {
                          "type": "string",
                          "enum": [
                            "NOK",
                            "USD",
                            "EUR",
                            "DKK"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ],
                  "nullable": true
                }
              },
              "additionalProperties": false
            },
            "fieldSources": {
              "type": "array",
              "nullable": true,
              "description": "Kilden til hver verdi denne endringen setter: én oppføring per felt eller listeelement du fyller inn. path følger formen på endringen du sender, f.eks. eventData.title eller publicContext.procedureType. Et listeelement angis med posisjonen i lista du sender, f.eks. eventData.minimumRequirements[2]; en sti til hele lista gjelder hvert element denne endringen legger til eller endrer. source.kind sier hvor verdien kom fra: USER_ANSWER (brukerens svar), UPLOADED_DOCUMENT (krever fileName og page eller section, gjerne også documentId), REQUIREMENT_LIBRARY (krever libraryElementId fra listLibraryElements), EARLIER_PROCUREMENT (krever sourcingEventId), EARLIER_CONTRACT (krever contractId), NEED (krever needId), PRODUCT_RULES (gjerne rule) eller ASSISTANT_SUGGESTION. Mangler en kilde det den krever, lagres feltets standardkilde. En kilde gjelder bare felt denne skrivingen endrer.",
              "items": {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string"
                  },
                  "source": {
                    "type": "object",
                    "properties": {
                      "kind": {
                        "type": "string",
                        "enum": [
                          "USER_ANSWER",
                          "UPLOADED_DOCUMENT",
                          "REQUIREMENT_LIBRARY",
                          "EARLIER_PROCUREMENT",
                          "EARLIER_CONTRACT",
                          "NEED",
                          "PRODUCT_RULES",
                          "ASSISTANT_SUGGESTION"
                        ]
                      },
                      "documentId": {
                        "type": "string",
                        "nullable": true
                      },
                      "fileName": {
                        "type": "string",
                        "nullable": true
                      },
                      "page": {
                        "type": "integer",
                        "nullable": true,
                        "format": "int32"
                      },
                      "section": {
                        "type": "string",
                        "nullable": true
                      },
                      "libraryElementId": {
                        "type": "string",
                        "nullable": true
                      },
                      "libraryElementTitle": {
                        "type": "string",
                        "nullable": true
                      },
                      "sourcingEventId": {
                        "type": "string",
                        "nullable": true
                      },
                      "contractId": {
                        "type": "string",
                        "nullable": true
                      },
                      "needId": {
                        "type": "string",
                        "nullable": true
                      },
                      "title": {
                        "type": "string",
                        "nullable": true
                      },
                      "rule": {
                        "type": "string",
                        "nullable": true
                      }
                    },
                    "required": [
                      "kind"
                    ],
                    "additionalProperties": false
                  }
                },
                "required": [
                  "path",
                  "source"
                ],
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    ]
  },
  {
    "toolName": "createSourcingEventTextDocument",
    "method": "POST",
    "riskTier": "reversible",
    "module": "assistant",
    "description": "Oppretter et dokument på steget Dokumenter i en anskaffelse og skriver hele utkastet i det. Gi dokumentet et navn slik det skal stå i dokumentlista, velg kategorien det hører til, og beskriv i instructions formålet og det fra anskaffelsen utkastet skal bygge på. chapters har alltid hele planen; skrives dokumentet i deler, har chaptersNow de første kapitlene som skrives nå, og resten skrives etterpå inn i det samme dokumentet med updateTextDocument, aldri i et nytt. Systemet skriver utkastet etter at brukeren har bekreftet, og dokumentet ligger så i lista på steget, der brukeren kan åpne og redigere det.",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "schema": {
          "type": "string",
          "minLength": 1
        },
        "required": true,
        "description": "Id-en til anskaffelsen dokumentet hører til"
      },
      {
        "name": "document",
        "in": "body",
        "required": true,
        "schema": {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "name",
            "category",
            "chapters",
            "instructions"
          ],
          "properties": {
            "name": {
              "type": "string",
              "minLength": 1,
              "description": "Dokumentets navn slik det skal stå i dokumentlista, f.eks. «Kravspesifikasjon – Renhold»"
            },
            "category": {
              "type": "string",
              "enum": [
                "COMPETITION_BASIS",
                "REQUIREMENTS_SPEC",
                "PRICE_SHEET",
                "CONTRACT",
                "OTHER"
              ],
              "description": "Kategorien dokumentet får i kolonnen «Kategori» på steget Dokumenter"
            },
            "chapters": {
              "type": "array",
              "minItems": 1,
              "items": {
                "type": "string",
                "minLength": 1
              },
              "description": "Titlene på ALLE kapitlene dokumentet skal ha, i rekkefølge, uten nummer foran: hele planen brukeren ba om eller du foreslo, også når bare de første skrives nå. Kort den aldri ned til kapitlene i første del"
            },
            "chaptersNow": {
              "type": "array",
              "items": {
                "type": "string",
                "minLength": 1
              },
              "description": "Bare når dokumentet skal skrives i deler: titlene på de første kapitlene i chapters, de som skrives nå, nøyaktig som i chapters. Resten skrives etterpå inn i det samme dokumentet. Ellers utelates feltet"
            },
            "shortChapters": {
              "type": "array",
              "items": {
                "type": "string",
                "minLength": 1
              },
              "description": "Bare når et svar har sagt at et kapittel ikke fikk plass i én omgang og brukeren har valgt å få det kortere: titlen på det kapittelet, nøyaktig som i chapters. Ellers utelates feltet"
            },
            "instructions": {
              "type": "string",
              "minLength": 1,
              "description": "Hva dokumentet skal inneholde: formålet og det fra anskaffelsen utkastet skal bygge på"
            }
          }
        }
      }
    ]
  },
  {
    "toolName": "updateTextDocument",
    "method": "PUT",
    "riskTier": "reversible",
    "module": "assistant",
    "description": "Skriver de neste kapitlene i et dokument på steget Dokumenter og legger dem til etter det som står der. Bruk det bare når svaret om dokumentet lister kapitler under chaptersRemaining: gi document.id, navnet og de samme instructions, og chapters nøyaktig som chaptersRemaining. Systemet skriver kapitlene etter at brukeren har bekreftet, hopper over kapitler dokumentet allerede har, og endrer aldri det som står der fra før.",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "schema": {
          "type": "string",
          "minLength": 1
        },
        "required": true,
        "description": "Id-en til anskaffelsen dokumentet hører til"
      },
      {
        "name": "documentId",
        "in": "path",
        "schema": {
          "type": "string",
          "minLength": 1
        },
        "required": true,
        "description": "Id-en til dokumentet, fra document.id i svaret som opprettet det"
      },
      {
        "name": "document",
        "in": "body",
        "required": true,
        "schema": {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "name",
            "chapters",
            "instructions"
          ],
          "properties": {
            "name": {
              "type": "string",
              "minLength": 1,
              "description": "Dokumentets navn slik det står i dokumentlista"
            },
            "chapters": {
              "type": "array",
              "minItems": 1,
              "items": {
                "type": "string",
                "minLength": 1
              },
              "description": "Kapitlene som skal legges til, nøyaktig som chaptersRemaining i forrige svar om dokumentet"
            },
            "shortChapters": {
              "type": "array",
              "items": {
                "type": "string",
                "minLength": 1
              },
              "description": "Bare når et svar har sagt at et kapittel ikke fikk plass i én omgang og brukeren har valgt å få det kortere: titlen på det kapittelet, nøyaktig som i chapters. Ellers utelates feltet"
            },
            "instructions": {
              "type": "string",
              "minLength": 1,
              "description": "Det samme som instructions da dokumentet ble opprettet"
            }
          }
        }
      }
    ]
  },
  {
    "toolName": "listSourcingEventFieldSources",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Henter kilden til hvert felt assistenten har fylt inn på en anskaffelse (brukerens svar, opplastet fil og side, Kravbibliotek-element, tidligere anskaffelse eller kontrakt, behov, regelverket eller assistentens forslag), om brukeren bekreftet det, og om brukeren har endret feltet for hånd etterpå. Bruk dette når brukeren spør hvor en verdi kom fra. Finnes det ingen kilde for et felt, er feltet ikke fylt inn av assistenten, og det er ikke lagret noen kilde – gjett aldri.",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "listLibraryElements",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Henter Kravbibliotek: organisasjonens egne og SourceMagnets standard minstekrav og kvalifikasjonskrav. Bruk id-en til elementet som kilde når du tar et krav herfra.",
    "params": []
  },
  {
    "toolName": "confirmSourcingEventClassification",
    "method": "POST",
    "riskTier": "reversible",
    "module": "assistant",
    "description": "Bekrefter klassifiseringssteget, så anskaffelsen får regelverket og delen verdien og organisasjonen tilsier.",
    "entityKind": "v2Event",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "confirmClassificationRequest",
        "in": "body",
        "required": true,
        "schema": {
          "type": "object",
          "properties": {
            "announcePartIOnDoffin": {
              "type": "boolean",
              "nullable": true
            }
          },
          "additionalProperties": false
        }
      }
    ]
  },
  {
    "toolName": "createProject",
    "method": "POST",
    "riskTier": "reversible",
    "module": "assistant",
    "description": "Oppretter et nytt prosjekt med navn og eventuelt beskrivelse, datoer og ekstern id.",
    "entityKind": "project",
    "params": [
      {
        "name": "homeDepartment",
        "in": "body",
        "schema": {
          "type": "string",
          "minLength": 1
        },
        "required": false,
        "description": "NAVNET på avdelingen prosjektet skal ligge under (ikke en id). Systemmeldingen lister avdelingene du kan opprette prosjekter i. Utelat hvis det bare er én; spør brukeren hvis det er flere."
      },
      {
        "name": "name",
        "in": "body",
        "schema": {
          "type": "string",
          "minLength": 1
        },
        "required": true,
        "description": "Prosjektets navn"
      },
      {
        "name": "description",
        "in": "body",
        "schema": {
          "type": "string"
        },
        "required": false
      },
      {
        "name": "startDate",
        "in": "body",
        "schema": {
          "type": "string",
          "format": "date"
        },
        "required": false,
        "description": "ÅÅÅÅ-MM-DD"
      },
      {
        "name": "endDate",
        "in": "body",
        "schema": {
          "type": "string",
          "format": "date"
        },
        "required": false,
        "description": "ÅÅÅÅ-MM-DD"
      },
      {
        "name": "externalId",
        "in": "body",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Prosjektnummer i et annet system"
      }
    ]
  },
  {
    "toolName": "updateProject",
    "method": "PATCH",
    "riskTier": "reversible",
    "module": "assistant",
    "description": "Endrer feltene på et prosjekt: navn, beskrivelse, start- og sluttdato, ekstern id. Send bare feltene som skal endres; null tømmer et felt.",
    "entityKind": "project",
    "params": [
      {
        "name": "projectId",
        "in": "path",
        "schema": {
          "type": "string",
          "description": "Prosjektets id fra et tidligere verktøyresultat"
        },
        "required": true
      },
      {
        "name": "projectPatchDto",
        "in": "body",
        "required": true,
        "schema": {
          "type": "object",
          "description": "Bare feltene som skal endres. null tømmer et felt; navnet kan ikke tømmes.",
          "properties": {
            "name": {
              "type": "string",
              "minLength": 1
            },
            "description": {
              "type": "string",
              "nullable": true
            },
            "startDate": {
              "type": "string",
              "format": "date",
              "nullable": true,
              "description": "ÅÅÅÅ-MM-DD"
            },
            "endDate": {
              "type": "string",
              "format": "date",
              "nullable": true,
              "description": "ÅÅÅÅ-MM-DD"
            },
            "externalId": {
              "type": "string",
              "nullable": true
            }
          }
        }
      }
    ]
  },
  {
    "toolName": "createContract",
    "method": "POST",
    "riskTier": "reversible",
    "module": "assistant",
    "description": "Oppretter en ny kontrakt (utkast).",
    "entityKind": "contract",
    "params": [
      {
        "name": "homeDepartment",
        "in": "body",
        "schema": {
          "type": "string",
          "minLength": 1
        },
        "required": false,
        "description": "NAVNET på avdelingen kontrakten skal ligge under (ikke en id). Systemmeldingen lister avdelingene du kan opprette i. Utelat hvis det bare er én; spør brukeren hvis det er flere."
      },
      {
        "name": "title",
        "in": "body",
        "schema": {
          "type": "string",
          "minLength": 1
        },
        "required": true,
        "description": "Kontraktens navn/tittel"
      }
    ]
  },
  {
    "toolName": "updateContract",
    "method": "POST",
    "riskTier": "reversible",
    "module": "assistant",
    "description": "Oppdaterer feltene på en kontrakt: navn, motpart (via organisasjonssøk), verdi, start- og sluttdato, beskrivelse, ansvarlig person.",
    "entityKind": "contract",
    "params": [
      {
        "name": "contractId",
        "in": "path",
        "schema": {
          "type": "string",
          "description": "Kontraktens id fra et tidligere verktøyresultat"
        },
        "required": true
      },
      {
        "name": "updateContractRequest",
        "in": "body",
        "required": false,
        "description": "Feltene som skal oppdateres på kontrakten",
        "schema": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string",
              "minLength": 1
            },
            "description": {
              "type": "string",
              "minLength": 1
            },
            "counterparty": {
              "type": "object",
              "description": "Motpart (leverandør, kunde eller annen part)",
              "required": [
                "counterparty"
              ],
              "properties": {
                "counterparty": {
                  "type": "object",
                  "properties": {
                    "organizationId": {
                      "type": "string",
                      "minLength": 1,
                      "description": "Fra organisasjonssøket, når treffet er en registrert Organization"
                    },
                    "organizationEntryId": {
                      "type": "string",
                      "minLength": 1,
                      "description": "Fra organisasjonssøket når treffet er en manuell oppføring (type OrganizationEntry)"
                    }
                  }
                }
              }
            },
            "valueAmount": {
              "type": "object",
              "properties": {
                "amount": {
                  "type": "integer",
                  "description": "Kontraktsverdi i NOK (heltall)"
                }
              }
            },
            "startDate": {
              "type": "object",
              "properties": {
                "date": {
                  "type": "string",
                  "minLength": 1,
                  "description": "ISO-dato, f.eks. 2026-06-15"
                }
              }
            },
            "endDate": {
              "type": "object",
              "required": [
                "hasNoEndDate"
              ],
              "properties": {
                "date": {
                  "type": "string",
                  "minLength": 1
                },
                "hasNoEndDate": {
                  "type": "boolean"
                }
              }
            },
            "internalOwner": {
              "type": "object",
              "required": [
                "personId"
              ],
              "properties": {
                "personId": {
                  "type": "string",
                  "minLength": 1
                }
              }
            }
          }
        }
      }
    ]
  },
  {
    "toolName": "publishContract",
    "method": "PUT",
    "riskTier": "reversible",
    "module": "assistant",
    "description": "Publiserer en kontrakt (utkast → publisert). Statusen kan ikke settes tilbake til utkast, men feltene kan fortsatt endres etterpå.",
    "entityKind": "contract",
    "params": [
      {
        "name": "contractId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "searchOrganizationsAndEntries",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Søker etter organisasjoner etter navn eller organisasjonsnummer, f.eks. for å finne en kontraktsmotpart.",
    "params": [
      {
        "name": "name",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "organizationNumber",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "limit",
        "in": "query",
        "required": true,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "skip",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "type",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string",
          "enum": [
            "Organization",
            "OrganizationEntry"
          ]
        }
      },
      {
        "name": "excludeLinkedEntries",
        "in": "query",
        "required": false,
        "schema": {
          "type": "boolean"
        }
      },
      {
        "name": "counties",
        "in": "query",
        "required": false,
        "description": "Two-digit county numbers, comma separated",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "municipalities",
        "in": "query",
        "required": false,
        "description": "Municipality numbers, comma separated",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "naceCodes",
        "in": "query",
        "required": false,
        "description": "NACE codes from Brønnøysund, comma separated",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "relations",
        "in": "query",
        "required": false,
        "description": "SupplierRelationDto values, comma separated",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "withRelations",
        "in": "query",
        "required": false,
        "schema": {
          "type": "boolean"
        }
      },
      {
        "name": "withoutRelations",
        "in": "query",
        "required": false,
        "description": "SupplierRelationDto values to leave out, comma separated",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "withFacets",
        "in": "query",
        "required": false,
        "schema": {
          "type": "boolean"
        }
      },
      {
        "name": "excludeOwnOrganization",
        "in": "query",
        "required": false,
        "description": "Leaves out the organization the caller works in",
        "schema": {
          "type": "boolean"
        }
      },
      {
        "name": "contractField",
        "in": "query",
        "required": false,
        "description": "A marked contract field and one value, as fieldId:value, once per value",
        "schema": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      {
        "name": "contractFieldAtLeast",
        "in": "query",
        "required": false,
        "description": "A marked number, amount or percentage field and its lowest value, as fieldId:value; a percentage in percent",
        "schema": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      {
        "name": "contractFieldPeriod",
        "in": "query",
        "required": false,
        "description": "A marked date field and a period, as fieldId:from:to with ISO dates; either end may be empty",
        "schema": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      {
        "name": "contractEndDateFrom",
        "in": "query",
        "required": false,
        "description": "Contracts whose end date is on or after this date",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "contractEndDateTo",
        "in": "query",
        "required": false,
        "description": "Contracts whose end date is on or before this date",
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "getOrganization",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Henter profilen til en registrert organisasjon. Bruk orgId.",
    "entityKind": "organization",
    "params": [
      {
        "name": "orgId",
        "in": "path",
        "schema": {
          "type": "string",
          "minLength": 1
        },
        "required": true,
        "description": "Id-en til organisasjonen som skal hentes (fra sidekonteksten eller organisasjonssøket) — IKKE din egen organisasjons-id"
      }
    ]
  },
  {
    "toolName": "getOrganizationEntry",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Henter en bedriftsoppføring fra markedsregisteret. Bruk entryId.",
    "entityKind": "orgEntry",
    "params": [
      {
        "name": "entryId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "searchBrregOrgsByName",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Søker i Brønnøysundregistrene etter norske selskaper på navn — bruk dette for å finne korrekt navn, organisasjonsnummer og adresse før en ny motpart opprettes.",
    "params": [
      {
        "name": "query",
        "in": "query",
        "required": true,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "limit",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      }
    ]
  },
  {
    "toolName": "lookupBrregOrg",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Slår opp ett selskap i Brønnøysundregistrene på organisasjonsnummer (9 siffer).",
    "params": [
      {
        "name": "organizationNumber",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "createOrganizationEntry",
    "method": "POST",
    "riskTier": "reversible",
    "module": "assistant",
    "description": "Oppretter en bedriftsoppføring i markedsregisteret, f.eks. en ny kontraktsmotpart som ikke finnes i organisasjonssøket. Slå opp selskapet i Brønnøysundregistrene først.",
    "entityKind": "orgEntry",
    "params": [
      {
        "name": "name",
        "in": "body",
        "schema": {
          "type": "string",
          "minLength": 2
        },
        "required": true,
        "description": "Selskapets navn — helst nøyaktig slik Brønnøysund-søket returnerte det"
      },
      {
        "name": "organizationNumber",
        "in": "body",
        "schema": {
          "type": "string",
          "minLength": 9,
          "maxLength": 9
        },
        "required": true,
        "description": "Organisasjonsnummer (9 siffer) fra Brønnøysund-søket"
      },
      {
        "name": "street",
        "in": "body",
        "schema": {
          "type": "string"
        },
        "required": false
      },
      {
        "name": "postCode",
        "in": "body",
        "schema": {
          "type": "string"
        },
        "required": false
      },
      {
        "name": "city",
        "in": "body",
        "schema": {
          "type": "string"
        },
        "required": false
      }
    ]
  },
  {
    "toolName": "readDocumentText",
    "method": "GET",
    "riskTier": "none",
    "module": "documentChat",
    "description": "Leser teksten i ett opplastet eller signert dokument, i deler. Send documentId for et opplastet dokument eller signedDocumentId for et signert. Er nextPart satt, finnes det mer: les videre med fromPart = nextPart før du svarer på noe som kan stå lenger ut. Hver PDF-side starter med «[Side N]» — oppgi dokumentets navn og sidetallet som kilde i svaret.",
    "params": [
      {
        "name": "documentId",
        "in": "query",
        "required": false,
        "description": "The uploaded document's id",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "signedDocumentId",
        "in": "query",
        "required": false,
        "description": "The signed document's id",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "fromPart",
        "in": "query",
        "required": false,
        "description": "The part to start reading at: 1, or nextPart",
        "schema": {
          "type": "integer"
        }
      }
    ]
  },
  {
    "toolName": "readConversationFile",
    "method": "GET",
    "riskTier": "none",
    "module": "assistant",
    "description": "Leser teksten i en fil brukeren har lagt ved i denne samtalen, i deler. Send documentId fra vedlegget. Er nextPart satt, finnes det mer: les videre med fromPart = nextPart før du svarer på noe som kan stå lenger ut. Hver PDF-side starter med «[Side N]» og hvert Word-avsnitt med «[Avsnitt N: overskrift]» — oppgi filens navn og siden eller avsnittet som kilde for alt du henter fra filen.",
    "params": [
      {
        "name": "documentId",
        "in": "query",
        "required": true,
        "description": "The document id of a file in this conversation",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "fromPart",
        "in": "query",
        "required": false,
        "description": "The part to start reading at: 1, or nextPart",
        "schema": {
          "type": "integer"
        }
      }
    ]
  }
];

export const agentClientToolCatalog: AgentClientToolDescriptor[] = [
  {
    "name": "navigate",
    "riskTier": "none",
    "module": "assistant",
    "description": "Naviger brukeren til en side eller en bestemt enhet (kontrakt/anskaffelse) via id.",
    "parameters": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Enhetens id fra et tidligere verktøyresultat"
        },
        "route": {
          "type": "string",
          "description": "Eksplisitt rute for oversiktssider"
        }
      }
    }
  },
  {
    "name": "search_tender_documents",
    "riskTier": "none",
    "module": "documentChat",
    "description": "Søk i innholdet i organisasjonens indekserte dokumenter (kontrakter, anskaffelser, vedlegg). Søket er avgrenset til det brukeren har tilgang til, så et tomt resultat betyr ikke at dokumentet ikke finnes. Treffene navngir dokument og sidetall — bruk dem som kilder i svaret.",
    "parameters": {
      "type": "object",
      "properties": {
        "query": {
          "type": "string"
        },
        "scope": {
          "type": "string",
          "enum": [
            "page",
            "organization",
            "bids"
          ],
          "description": "«page» søker kun i dokumentene til enheten brukeren ser på; «organization» søker i hele arkivet og krever tillegget Kontraktsøk; «bids» søker i innleverte tilbud på anskaffelsen brukeren ser på (f.eks. for å sammenligne tilbudene)"
        }
      },
      "required": [
        "query",
        "scope"
      ]
    }
  },
  {
    "name": "open_document",
    "riskTier": "none",
    "module": "assistant",
    "description": "Legg et dokument klart for nedlasting som et kort under svaret — bruk dette når brukeren ber om å åpne eller laste ned et dokument.",
    "parameters": {
      "type": "object",
      "properties": {
        "documentId": {
          "type": "string",
          "description": "Dokumentets id fra et tidligere verktøyresultat"
        },
        "name": {
          "type": "string",
          "description": "Dokumentets navn, vises på kortet"
        }
      },
      "required": [
        "documentId"
      ]
    }
  },
  {
    "name": "get_procurement_rules",
    "riskTier": "none",
    "module": "assistant",
    "description": "Henter hvilken del av anskaffelsesregelverket som gjelder for en anskaffelse, hvilke prosedyrer brukeren kan velge med hjemmel, og minstefristene for tilbud og forespørsel per prosedyre. Svaret bygger på de samme reglene som veiviseren. Kall dette før du nevner regelverksdel, prosedyre, hjemmel eller minstefrist, og nevn aldri en hjemmel eller en minstefrist som ikke står i svaret. Står det noe under missing, mangler anskaffelsen det reglene trenger: spør brukeren om det i stedet for å gjette.",
    "parameters": {
      "type": "object",
      "properties": {
        "eventId": {
          "type": "string",
          "description": "Anskaffelsens id fra et tidligere verktøyresultat eller siden brukeren ser på"
        }
      },
      "required": [
        "eventId"
      ]
    }
  },
  {
    "name": "draft_content",
    "riskTier": "none",
    "module": "assistant",
    "description": "Utarbeid et tekstutkast (svar, tildelingsbrev, beskrivelse).",
    "parameters": {
      "type": "object",
      "properties": {
        "kind": {
          "type": "string"
        },
        "instructions": {
          "type": "string"
        }
      },
      "required": [
        "kind",
        "instructions"
      ]
    }
  }
];
